import { ChangeEvent, SetStateAction } from "react";
import { Option } from "../../../types/General/Option";
import { Flex } from "@chakra-ui/react";
import SelectComponent from "../../../components/molecule/Select/SelectComponent";
import DatePickerComponent from "../../../components/molecule/DatePicker/DatePickerComponent";
import { Dayjs } from "dayjs";
import { AuthUser } from "../../../types/User/AuthUser";

export const bulletinsTableSelectFilterData = (
  typeOptions: Option[],
  provinceOptions: Option[],
  countyOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedType: SetStateAction<any>,
  setSelectedMonth: SetStateAction<any>,
  setSelectedYear: SetStateAction<any>,
  setSelectedProvince: SetStateAction<any>,
  setSelectedCounty: SetStateAction<any>,
  selectedProvince: Option | null,
  selectedMonth: Dayjs | null,
  selectedYear: Dayjs | null,
  provinceLoaded: boolean,
  countyLoaded: boolean,
  typeLoaded: boolean,
  user: AuthUser,
) => {
  const handleTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedTypeId = e.target.value;
    const selected = typeOptions.find(
      (p) => p.id.toString() === selectedTypeId,
    );
    setSelectedType(selected || null);
    setFilter("TypeId", selectedTypeId);
  };
  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };
  const handleCountyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedCountyId = e.target.value;
    const selected = countyOptions.find(
      (p) => p.id.toString() === selectedCountyId,
    );
    setSelectedCounty(selected || null);
    setFilter("CountyId", selectedCountyId);
  };

  const handleMonthChange = (date: any) => {
    setSelectedMonth(date || null);
    setFilter("Month", date ? date.format("M") : "");
  };
  const handleYearChange = (date: any) => {
    setSelectedYear(date || null);
    setFilter("Year", date ? date.format("YYYY") : "");
  };

  return (
    <Flex
      justifyContent="flex-start"
      alignItems="flex-start"
      gap="4"
      width="230px"
    >
      <SelectComponent
        fieldNameObject="TypeId"
        options={typeOptions}
        fieldName="Tipo de boletim"
        control={control}
        width="230px"
        onChange={handleTypeChange}
        isLoaded={typeLoaded}
      />
      <DatePickerComponent
        label="Mês"
        fieldName="Month"
        selectedDate={selectedMonth}
        onChange={handleMonthChange}
        mode="month"
        format="MMMM"
        control={control}
        width="230px"
      />
      <DatePickerComponent
        label="Ano"
        fieldName="Year"
        selectedDate={selectedYear}
        onChange={handleYearChange}
        mode="year"
        format="YYYY"
        control={control}
        width="230px"
      />
      <SelectComponent
        fieldNameObject="ProvinceId"
        options={provinceOptions}
        fieldName="Província"
        control={control}
        width="230px"
        onChange={handleProvinceChange}
        isLoaded={provinceLoaded}
        isDisabled={user?.role?.level !== undefined && user?.role.level.id >= 4}
        defaultValue={
          user?.role?.level !== undefined && user?.role.level.id >= 4
            ? user.province?.id
            : ""
        }
      />
      <SelectComponent
        fieldNameObject="CountyId"
        options={countyOptions}
        fieldName="Município"
        control={control}
        width="230px"
        onChange={handleCountyChange}
        isDisabled={
          (user?.role?.level !== undefined && user?.role.level.id === 5) ||
          !selectedProvince ||
          selectedProvince.name === ""
        }
        isLoaded={countyLoaded}
        defaultValue={
          user?.role?.level !== undefined && user?.role.level.id === 5
            ? user.county?.id
            : ""
        }
      />
    </Flex>
  );
};
